export function stopPropagation(ev) {
    var _a;
    (_a = ev === null || ev === void 0 ? void 0 : ev.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(ev);
}
export function preventDefault(ev) {
    var _a;
    (_a = ev === null || ev === void 0 ? void 0 : ev.preventDefault) === null || _a === void 0 ? void 0 : _a.call(ev);
}
export function isRightClick(ev) {
    return ev.button === 2;
}
export function isLeftClick(ev) {
    return ev.button === 0;
}
export function isMiddleClick(ev) {
    return ev.button === 1;
}
//# sourceMappingURL=dom.js.map